// extracted by mini-css-extract-plugin
export default {"container":"container-TZirRk","back":"back-KeoSku","icon":"icon-fQk_yq","active":"active-C0Y0SE","text":"text-HqXs2A","tickIcon":"tickIcon-QHUJF5"};